module.exports = __webpack_public_path__ + "static/media/payment_icon.58ca0fa4.png";